import { useLocation } from 'react-router-dom';
import AutomationWizard from './AutomationFlowWizard';
import CrGnbAutomationWizard from './CrGnbAutomationWizard';
import RAppsAutomationWizard from './RAppsAutomationWizard';
import PurposeBuiltAutomationWizard from './PurposeBuiltAutomationWizard';

export default function AutomationFlowWizardRouter() {
  const location = useLocation();
  const template = location.state?.selectedCard?.backendTemplate;
  const productType = location.state?.preSelectedProductType;

  if (productType === 'gNB') {
    return <CrGnbAutomationWizard />;
  }

  if (productType === 'rApps') {
    return <RAppsAutomationWizard />;
  }

  if (productType === 'Purpose Built') {
    return <PurposeBuiltAutomationWizard />;
  }

  // Fallback for CNIS (still uses generic wizard)
  switch (template) {
    case 'Full_Automation':
      return <AutomationWizard mode="full" />;
    case 'Onboarding_Only':
      return <AutomationWizard mode="onboarding" />;
    case 'Onboarding_Deployment':
      return <AutomationWizard mode="onboarding" />;
    default:
      return <AutomationWizard mode="onboarding" />;
  }
}
